import { render, staticRenderFns } from "./ProductManagerView.vue?vue&type=template&id=9eafd44e&scoped=true"
import script from "./ProductManagerView.vue?vue&type=script&lang=js"
export * from "./ProductManagerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eafd44e",
  null
  
)

export default component.exports